// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VqXa","colBig":"styles_colBig__2tDmN","colSmall":"styles_colSmall__1ftaJ"};